import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/AccountAnalyticDetailsV2.graphql';
import { Query, QueryaccountAnalyticDetailsV2Args } from '../../__generated__/globalTypes';

export const useAccountAnalyticDetailsV2Query = (
  options?: QueryHookOptions<Query, QueryaccountAnalyticDetailsV2Args>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryaccountAnalyticDetailsV2Args>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useAccountAnalyticDetailsV2LazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryaccountAnalyticDetailsV2Args>
): QueryResult<Query, QueryaccountAnalyticDetailsV2Args> & {
  getAccountAnalyticDetailsV2: LazyQueryExecFunction<Query, QueryaccountAnalyticDetailsV2Args>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getAccountAnalyticDetailsV2, result] = useLazyQuery<Query, QueryaccountAnalyticDetailsV2Args>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getAccountAnalyticDetailsV2, ...result };
};

export const useAccountAnalyticDetailsV2PromiseQuery = () => {
  const client = useApolloClient();

  const getAccountAnalyticDetailsV2 = useCallback(
    (options?: Omit<QueryOptions<QueryaccountAnalyticDetailsV2Args, Query>, 'query'>) =>
      client.query<Query, QueryaccountAnalyticDetailsV2Args>({ ...options, query: QUERY }),
    [client]
  );

  return { getAccountAnalyticDetailsV2 };
};
// Suspense Query Hooks
export const useAccountAnalyticDetailsV2SuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryaccountAnalyticDetailsV2Args>
) => {
  const result = useSuspenseQuery<Query, QueryaccountAnalyticDetailsV2Args>(QUERY, {
    ...options
  });

  return result;
};
